function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Maintains a promise that will be unresolved when "busy" and resolved when "not busy".
 * Set the busy status by calling start(), then call the returned function when done.
 *
 * @example
 *     const indicator = new BusyIndicator();
 *     const done = indicator.start();
 *     doSomeWork().finally(done);
 *
 * @property {Promise} promise - The promise to pass to cgBusy, indicating this BusyIndicator is active
*/
var BusyIndicator = /*#__PURE__*/function () {
  function BusyIndicator() {
    _classCallCheck(this, BusyIndicator);
    this._stack = [];
  }

  /**
   * Ensures this BusyIndicator will be "busy" until the returned function is called.
   * @returns {Function} - Call this function to indicate you are no longer busy.
   */
  return _createClass(BusyIndicator, [{
    key: "start",
    value: function start() {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      // The arguments are used as an identity, so we know when we are
      // popping "this" operation from the stack.
      this._stack.push(args);
      if (this._stack.length == 1) {
        // This is the promise that cgBusy should monitor
        this.promise = new Promise(function (resolve) {
          _this._resolve = resolve;
        });
      }
      return function () {
        return _this._stop(args);
      };
    }
  }, {
    key: "_stop",
    value: function _stop(args) {
      var ix = this._stack.indexOf(args);
      if (ix > -1) {
        this._stack.splice(ix, 1);
        if (this._stack.length == 0) {
          this._resolve();
        }
      }
    }

    /**
     * Forces the BusyIndicator to move to the "not busy" state.
     * This is not normally required.
     */
  }, {
    key: "cancel",
    value: function cancel() {
      var shouldResolve = this._stack.length > 0;
      this._stack = [];
      if (shouldResolve) {
        this._resolve();
      }
    }
  }]);
}();
export { BusyIndicator as default };